import { Location_Metrics_Mobile_Pay_Filter } from '@occc/graphql';

export const TRANSACTION_SET_SELECTION_STORAGE_KEY = 'retailer-connect.transaction-set';

const TRANSACTION_SETS = Object.values(Location_Metrics_Mobile_Pay_Filter);

const isTransactionSet = (value: unknown): value is Location_Metrics_Mobile_Pay_Filter =>
  TRANSACTION_SETS.includes(value as Location_Metrics_Mobile_Pay_Filter);

// Reads sessionStorage directly rather than through the app's LocalStorage helper:
// this module is pulled into the app's logout path, and importing app code from
// here would close a dependency cycle between the library and the app.
export const loadTransactionSetSelection = (): Location_Metrics_Mobile_Pay_Filter | undefined => {
  const stored = window.sessionStorage.getItem(TRANSACTION_SET_SELECTION_STORAGE_KEY);
  return isTransactionSet(stored) ? stored : undefined;
};

export const saveTransactionSetSelection = (value: Location_Metrics_Mobile_Pay_Filter): void => {
  window.sessionStorage.setItem(TRANSACTION_SET_SELECTION_STORAGE_KEY, value);
};

export const clearTransactionSetSelection = (): void => {
  window.sessionStorage.removeItem(TRANSACTION_SET_SELECTION_STORAGE_KEY);
};
